/*
 * @Descripttion: 百家云直播
 * @Author: gouyang
 * @Date: 2021-01-22 09:26:18
 * @LastEditors: gouyang
 * @LastEditTime: 2021-01-26 10:17:13
 */
import React, { memo, useCallback, useEffect, useState } from 'react';
import { getOrgName, getToken, getUserId, getUsername } from '../../../../util';
import apiConfig from '../../../../config/api';
import './index.less';

interface P {
  liveId: number;
  // liveTeacherInfo: LiveTeacherInfo;
  // liveUserInfo: LiveUserInfo;
}

function LiveBroadcast(props: P) {
  const { liveId } = props;
  const [url, setUrl] = useState<string>('');

  const enterLive = useCallback(async (liveId: number) => {
    const userId = getUserId();
    const liveUrl = apiConfig.easteduLiveUrl;
    const orgName = getOrgName();
    const name = getUsername();
    const userName = orgName ? `${orgName}-${name}` : name;
    setUrl(`${liveUrl}?liveId=${liveId}&userId=${userId}&userName=${userName}&token=${getToken()}`);
  }, []);

  useEffect(() => {
    if (liveId) {
      enterLive(liveId);
    }
  }, [liveId, enterLive]);

  return (
    <div className="live-broadcast">
      <div className="live-broadcast-content">
        <iframe
          allow="microphone;camera;midi;encrypted-media;display-capture;"
          allowFullScreen
          title="闻道直播"
          src={url}
        />
      </div>
    </div>
  );
}

export default memo(LiveBroadcast);
